import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { getStockAccessMessage } from '../carteDisplay'

const StockAccessInfo = ({ carte, variant = 'client', appearance = 'inline', className = '' }) => {
  const { t } = useTranslation()
  const message = getStockAccessMessage(carte, variant, t)
  if (!message) return null

  if (appearance === 'banner') {
    return (
      <div
        className={[
          'flex items-start gap-3 rounded-xl border border-brand-200/60 bg-gradient-to-r from-brand-50 to-violet-50/80 px-4 py-3',
          className,
        ].join(' ')}
      >
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-brand-100">
          <Info className="h-4 w-4 text-brand-600" aria-hidden />
        </span>
        <p className="pt-0.5 text-sm leading-relaxed text-brand-900">{message}</p>
      </div>
    )
  }

  return (
    <div className={['flex gap-1.5', className].join(' ')}>
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-500" aria-hidden />
      <p className="m-0 text-xs leading-relaxed text-gray-500">{message}</p>
    </div>
  )
}

export default StockAccessInfo
